const URL = {
  APPSUMO_CODE_CONFIRM: 'promoCode/validatePromoCode',
  APPSUMO_SIGNUP: 'auth/registerWithPromoCode',
  APPSUMO_CODE_REFUND: 'promoCode/refundPromoCode',
}

export default URL
